export enum EnumMagicStrings {
  tooltips = 'tooltips',
  localeLanguage = 'i18nextLng',
}

export enum EnumSnackbarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}
